import { Box, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export const formatMetricDate = (value) => {
    if (!value) return 'n/a';
    const date = new Date(`${value}T00:00:00Z`);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
};

export const formatMetricValue = (value, unit) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 'n/a';

    const normalizedUnit = String(unit || '').toLowerCase();
    const suffix = normalizedUnit.includes('million')
        ? 'M'
        : normalizedUnit.includes('billion')
            ? 'B'
            : normalizedUnit.includes('thousand')
                ? 'K'
                : normalizedUnit.includes('percent')
                    ? '%'
                    : '';

    const formatted = Math.abs(numeric) >= 100
        ? numeric.toLocaleString(undefined, { maximumFractionDigits: 0 })
        : numeric.toLocaleString(undefined, { maximumFractionDigits: 2 });

    return suffix === '%' ? `${formatted}%` : `${formatted}${suffix}`;
};

export function PublicPageShell({ children }) {
    return (
        <Box maxW="1180px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 8, md: 12 }}>
            {children}
        </Box>
    );
}

export function publicMetricCtaPath(ticker, destination, content, metricSlug) {
    const normalizedTicker = String(ticker || '').toLowerCase();
    const path = `/stock/${normalizedTicker}/${destination}`;
    const params = new URLSearchParams({
        utm_source: 'public_metrics',
        utm_medium: 'seo',
        utm_campaign: 'custom_metrics',
        utm_content: content,
    });

    if (metricSlug) {
        params.set('public_metric', metricSlug);
    }

    return `${path}?${params.toString()}`;
}

export function PublicMetricLink({ metric, children }) {
    const to = metric?.url || `/stocks/${String(metric?.ticker || '').toLowerCase()}/metrics/${metric?.metric_slug}`;
    return (
        <Link as={RouterLink} to={to} color="blue.600" fontWeight="semibold">
            {children || metric?.display_name}
        </Link>
    );
}

export function SourceCell({ value }) {
    const label = [value?.form, formatMetricDate(value?.filing_date)].filter(Boolean).join(' ');
    if (value?.source_url) {
        return (
            <Link href={value.source_url} target="_blank" rel="noopener noreferrer" color="blue.600">
                {label || value.source_label || 'Source filing'}
            </Link>
        );
    }
    if (value?.accession_number) {
        return <Text as="span">{value.accession_number}</Text>;
    }
    return <Text as="span" color="gray.500">n/a</Text>;
}
